module.exports = __webpack_public_path__ + "static/img/wubaojing.6d9d588.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/wubaojing.png
// module id = hI+1
// module chunks = 1